module.exports = __webpack_public_path__ + "img/op3.0eee85cf.png";